import { Kit, KitType, KitVariant } from '@repo/types';
import { AgeGroup, getAgeGroup } from '@repo/utils';

const FIRST_LOOK_CUTOFF_DATE = '2025-01-13';
const FIRST_LOOK_CUTOFF_DATE_V2_DEFAULT = '2026-04-09';

export interface FirstLookFeatureFlags {
  v2: boolean;
  v2Vaginal: boolean;
  v2OverrideDate?: Date;
}

export const shouldShowFirstLook = (
  kit: Kit | undefined,
  featureFlags: FirstLookFeatureFlags,
): boolean => {
  if (!kit) return false;

  const isPregnant = kit.pregnant === true || kit.pregnant === 1;
  if (isPregnant) return false;

  if (!kit.date_results_ready) return false;
  const resultsReadyDate = new Date(kit.date_results_ready);

  const v2CutoffDate = new Date(
    featureFlags.v2OverrideDate || FIRST_LOOK_CUTOFF_DATE_V2_DEFAULT,
  );
  const canShowV2 = resultsReadyDate >= v2CutoffDate;

  // V2 adds support for these cases
  if (!canShowV2 || !featureFlags.v2) {
    const kitAgeGroup = getAgeGroup(kit.age_at_sampling ?? 0);
    const isAdult = kitAgeGroup === AgeGroup.ADULT;
    if (!isAdult) return false;

    const hasStoolChemistryVariant = kit.variants?.some(
      (variant: KitVariant) => variant.sampling_type === 'stool_chemistry',
    );
    if (hasStoolChemistryVariant) return false;
  }

  if (!canShowV2 || !featureFlags.v2Vaginal) {
    const isStoolSample = kit.sampling_type === KitType.STOOL;
    if (!isStoolSample) return false;
  }

  const cutoffDate = new Date(FIRST_LOOK_CUTOFF_DATE);
  const isAfterCutoff = resultsReadyDate >= cutoffDate;
  if (!isAfterCutoff) return false;

  return true;
};
